function getAffinitySegments($i18n: any) {
  const segmentKeys = Object.keys($i18n.tm('tealium.segments'));
  const segmentsRedirects = new Map();

  segmentKeys.forEach((key) => {
    const label = $i18n.t(`tealium.segments.${key}`);
    const redirect = $i18n.t(`tealiumCategoryRedirect.${key}`);
    segmentsRedirects.set(label, redirect);
  });

  return segmentsRedirects;
}

function getAffinityCategoryRedirect(audiences: string[], $i18n: any): string | undefined {
  const affinitySegments = getAffinitySegments($i18n);

  const matched = Array.from(affinitySegments.entries())
    .filter(([segment]) => audiences.includes(segment))
    .map(([, type]) => type);
  return matched.length === 1 ? matched[0] : undefined;
}

export function useAffinityCookie() {
  const { $i18n } = useNuxtApp();
  const mainStore = useMainStore();
  const affinityRedirectPageCookie = useCookie('affinityRedirectPage', { maxAge: ONE_YEAR });

  function setAffinityCookie(audiences: string[]) {
    const affinityCategoryRedirect = getAffinityCategoryRedirect(audiences, $i18n);

    if (!mainStore.getFeature('affinityRedirectEnabled')) {
      affinityRedirectPageCookie.value = null;
      return;
    }
    affinityRedirectPageCookie.value = affinityCategoryRedirect || null;
  }

  return { setAffinityCookie, affinityRedirectPageCookie };
}
